import { PercentPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { MonitoramentoAcessoriosFiltroService } from './monitoramento-acessorios';
import { MonitoramentoAcessoriosService } from './monitoramento-acessorios.service';

declare var $: any;

@Component({
  selector: 'app-monitoramento-acessorios',
  templateUrl: './monitoramento-acessorios.component.html',
  styleUrls: ['./monitoramento-acessorios.component.scss']
})
export class MonitoramentoAcessoriosComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  origem = [];
  sub_grupo = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  carregando: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;

  percentual: any[] = [];

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Number": "businessIntelligence.monitoramentoAcessorios.dealerCod",
    "Dealer Name": "businessIntelligence.monitoramentoAcessorios.dealerName",
    "Data": "businessIntelligence.monitoramentoAcessorios.dataEmissao",
    "PartNumber": "businessIntelligence.monitoramentoAcessorios.partNumber",
    "Descrição": "businessIntelligence.monitoramentoAcessorios.descricaoItem",
    "Quantidade": "businessIntelligence.monitoramentoAcessorios.quantidade",
    "Valor de Venda": "businessIntelligence.monitoramentoAcessorios.valorVenda",
    "Origem": "businessIntelligence.monitoramentoAcessorios.origem",
    "tipoOs": "businessIntelligence.monitoramentoAcessorios.tiposervicoOrdem",
    "numeroOs": "businessIntelligence.monitoramentoAcessorios.numeroOs",
    "numeroChassi": "businessIntelligence.monitoramentoAcessorios.numeroChassi",
    "CPF/CNPJ": "businessIntelligence.monitoramentoAcessorios.documento",
    "Inventário Final Qtd.": "businessIntelligence.monitoramentoAcessorios.inventFinalQtd",
  }

  constructor(private service: MonitoramentoAcessoriosService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: MonitoramentoAcessoriosFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder,
    private percent: PercentPipe) {
    this.filtros = {};
    this.nomeModulo = 'monitoramento-acessorios';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      origem: [''],
      sub_grupo: [''],
      partNumber: [''],
      documento: [''],
      percentual: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.changeLanguageValue();
    this.preencherOrigem();
    this.preencherSubGrupo();
    this.preencherPercentual();

    this.carregando = true;

    this.cols = [
      { field: 'codDealer', header: 'businessIntelligence.monitoramentoAcessorios.dealerCod' },
      { field: 'nome', header: 'businessIntelligence.monitoramentoAcessorios.dealerName' },
      { field: 'data', header: 'businessIntelligence.monitoramentoAcessorios.dataEmissao' },
      { field: 'partNumber', header: 'businessIntelligence.monitoramentoAcessorios.partNumber' },
      { field: 'descricaoItem', header: 'businessIntelligence.monitoramentoAcessorios.descricaoItem' },
      { field: 'quantidade', header: 'businessIntelligence.monitoramentoAcessorios.quantidade' },
      { field: 'valorVenda', header: 'businessIntelligence.monitoramentoAcessorios.valorVenda' },
      { field: 'precoPublico', header: 'businessIntelligence.monitoramentoAcessorios.precoPublico' },
      { field: 'percentualOverPricing', header: 'businessIntelligence.monitoramentoAcessorios.percentualOverPricing', type: this.percent, arg1: '1.2-2' },
      { field: 'numeroVenda', header: 'businessIntelligence.monitoramentoAcessorios.numeroVenda' },
      { field: 'origem', header: 'businessIntelligence.monitoramentoAcessorios.origem' },
      { field: 'tipoOs', header: 'businessIntelligence.monitoramentoAcessorios.tiposervicoOrdem' },
      { field: 'numeroOs', header: 'businessIntelligence.monitoramentoAcessorios.numeroOs' },
      { field: 'numeroChassi', header: 'businessIntelligence.monitoramentoAcessorios.numeroChassi' },
      { field: 'documento', header: 'businessIntelligence.monitoramentoAcessorios.documento' },
      { field: 'nomeCliente', header: 'businessIntelligence.monitoramentoAcessorios.cliente' },
      { field: 'email', header: 'businessIntelligence.monitoramentoAcessorios.email' },
      { field: 'ddd', header: 'businessIntelligence.monitoramentoAcessorios.ddd' },
      { field: 'telefone', header: 'businessIntelligence.monitoramentoAcessorios.telefone' },
      { field: 'kmAtual', header: 'businessIntelligence.monitoramentoAcessorios.kmAtual' },
      { field: 'modelo', header: 'businessIntelligence.monitoramentoAcessorios.modelo' },
      { field: 'subGrupo', header: 'businessIntelligence.monitoramentoAcessorios.subGrupo' },
      { field: 'quantidadePecaOs', header: 'businessIntelligence.monitoramentoAcessorios.quantidadePecaOs' },
      { field: 'valorServicos', header: 'businessIntelligence.monitoramentoAcessorios.valorServico' }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private preencherOrigem() {
    this.origem = [
      { nome: 'A&L (Clothing)', valor: '1' },
      { nome: 'Balcão', valor: '2' },
      { nome: 'Oficina', valor: '3' },
      { nome: 'Outros', valor: '4' }
    ];
  }

  private preencherSubGrupo() {
    this.sub_grupo = [
      { nome: 'Óleo', valor: "LUB" },
      { nome: 'Fluído Freio + Arrefecimento', valor: "QUI" },
      { nome: 'Pneus', valor: "PNE" },
      { nome: 'Acessórios', valor: "ACC" },
      { nome: 'Baterias', valor: 'BAT'},
      { nome: 'Boutique', valor: 'CLO' },
      { nome: 'Peças originais', valor: 'GEN' },
      { nome: 'Personalização', valor: 'PER' },
      { nome: 'Estética', valor: 'EST' },
    ];
  }

  private getAll() {
    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.origem.value, this.f.sub_grupo.value, this.f.partNumber.value, this.f.documento.value, this.f.percentual.value).subscribe(dados => {
        this.dealersDados = dados.precos;
        this.orderByDate();

        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVenda = valorFormatado.replace("R$", "");

          const precoPublico = this.conversaoLibraConverte.conversaoLibra(element.precoPublico, null, null);
          const precoPublicoFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(precoPublico);
          element.precoPublico = precoPublicoFormatado.replace("R$", "");

          if (element.valorServicos !== undefined && element.valorServicos !== null) {
            const valorServicosConvertido = this.conversaoLibraConverte.conversaoLibra(element.valorServicos, null, null);
            const valorServicosFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(valorServicosConvertido);
            element.valorServicos = valorServicosFormatado.replace("R$", "");
          }

          element.data = element.data.substring(0, 10);
        });

        this.carregando = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.origem.value
      || this.f.sub_grupo.value
      || this.f.partNumber.value
      || this.f.documento.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.documento.setValue('');
    this.f.origem.setValue('');
    this.f.sub_grupo.setValue('');
    this.f.partNumber.setValue('');
    this.f.percentual.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.monitoramentoAcessorios.dealerCod") {
      return this.translate.currentLang == "br" ? "Cod. Dealer" : "Dealer Code";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.dealerName") {
      return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.dataEmissao") {
      return this.translate.currentLang == "br" ? "Data" : "Date";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.partNumber") {
      return this.translate.currentLang == "br" ? "PartNumber" : "partNumber";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.descricaoItem") {
      return this.translate.currentLang == "br" ? "Descrição" : "Description";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.quantidade") {
      return this.translate.currentLang == "br" ? "Quantidade" : "Amount";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.valorVenda") {
      return this.translate.currentLang == "br" ? "Valor de Venda" : "Sale Value";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.precoPublico") {
      return this.translate.currentLang == "br" ? "Preço Público" : "Public Price";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.percentualOverPricing") {
      return "OverPricing";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.numeroVenda") {
      return this.translate.currentLang == "br" ? "NF Venda" : "NF Sale";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.origem") {
      return this.translate.currentLang == "br" ? "Origem" : "Origin";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.documento") {
      return this.translate.currentLang == "br" ? "CPF/CNPJ" : "EN/SSN";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.cliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.email") {
      return "Email";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.ddd") {
      return "DDD";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.telefone") {
      return this.translate.currentLang == "br" ? "Telefone" : "Telephone";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.tiposervicoOrdem") {
      return this.translate.currentLang == "br" ? "Tipo de Serviço/Ordem" : "Type of Service/Order";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.numeroOs") {
      return this.translate.currentLang == "br" ? "Número da OS" : "Order Number";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.numeroChassi") {
      return this.translate.currentLang == "br" ? "Número do Chassi" : "Chassis Number";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.kmAtual") {
      return this.translate.currentLang == "br" ? "KM Atual" : "Current KM";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.modelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.subGrupo") {
      return this.translate.currentLang == "br" ? "Sub Grupo" : "Sub Group";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.quantidadePecaOs") {
      return this.translate.currentLang == "br" ? "Quantidade Peça OS" : "OS Parts Quantity";
    }
    if (item == "businessIntelligence.monitoramentoAcessorios.valorServico") {
      return this.translate.currentLang == "br" ? "Valor Serviços" : "Service Value";
    }

  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.origem.value, this.f.sub_grupo.value, this.f.partNumber.value, this.f.documento.value, this.f.percentual.value).subscribe(dados => {
        registros = dados.precos;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          dados.data = dados.data.substring(0, 10);
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          this.exportExcelService.colunasFormatacao = [8];
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.carregando = true;
        this.getAll();
      });
  }

  private preencherPercentual() {
    this.percentual = [
      { descricao: 'Maior/Igual que 100%', id: "1" },
      { descricao: 'Menor que 100%', id: "2" },
    ];
  }

  public ordenarTabela(event: any) {
    this.dealersDados.sort((a, b) => {
      let campo_a = a[event.field];
      let campo_b = b[event.field];

      if (campo_a > campo_b) return -1;
      if (campo_a < campo_b) return 1;

      return 0;
    });
  }

}
